import { CookieHandler } from './cookiehandler.js';
import { config } from './config.js';

export const LAST_LOGIN_STATE_COOKIE = 'ents_wl_last_login_state';
export const COOKIE_EXPIRATION_DAYS = 360;

export type LoginTransition = 'login' | 'logout' | 'none';

export function getLoginTransition(cookieHandler: CookieHandler): LoginTransition {
  const lastLoginState = cookieHandler.getCookie(LAST_LOGIN_STATE_COOKIE);
  const userIsLoggedIn = config.currentlyLoggedIn === 'true';
  if (userIsLoggedIn && lastLoginState === 'false') {
    return 'login';
  }
  if (!userIsLoggedIn && lastLoginState === 'true') {
    return 'logout';
  }
  return 'none';
}
